import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Bell } from "lucide-react";
import { useNotificationPreferences } from "@/hooks/useNotificationPreferences";
import { useNotificationPermissions } from "@/hooks/useNotificationPermissions";
import { useAuth } from "@/hooks/useAuth";
import NotificationPermissionBadge from "./notification/NotificationPermissionBadge";
import NotificationPermissionAlert from "./notification/NotificationPermissionAlert";
import TestNotificationPanel from "./notification/TestNotificationPanel";
import NotificationPreferences from "./notification/NotificationPreferences";
import NotificationDebugPanel from "./notification/NotificationDebugPanel";
import { VapidKeyUpdateBanner } from "./notification/VapidKeyUpdateBanner";

const NotificationSection = () => {
  const { user } = useAuth();
  const { preferences, loading, updatePreference } = useNotificationPreferences();
  const { 
    permissionStatus, 
    deviceRegistered, 
    requestNotificationPermission 
  } = useNotificationPermissions(user?.id);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <Bell className="w-5 h-5" />
              Push Notifications
            </CardTitle>
            <CardDescription>
              Manage your notification preferences and test notifications
            </CardDescription>
          </div>
          <NotificationPermissionBadge permissionStatus={permissionStatus} />
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <VapidKeyUpdateBanner />
        
        <NotificationPermissionAlert 
          permissionStatus={permissionStatus}
          onRequestPermission={requestNotificationPermission}
        />
        
        <TestNotificationPanel 
          userId={user?.id || ''}
          isVisible={permissionStatus === 'granted' && deviceRegistered}
        />
        
        <NotificationPreferences 
          preferences={preferences}
          loading={loading}
          onUpdatePreference={updatePreference}
        />

        <NotificationDebugPanel userId={user?.id} />
      </CardContent>
    </Card>
  );
};

export default NotificationSection;